import { render } from "./UserFollow.vue?vue&type=template&id=3a48d520"
import script from "./UserFollow.vue?vue&type=script&lang=js"
export * from "./UserFollow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__